import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon, EllipsisVerticalIcon } from "@heroicons/react/24/outline";

export function HseRowActionsMenu({
  items = [],
  label = "Handlinger",
  header,
  variant = "icon",
}) {
  const visible = items.filter((item) => item && item.hidden !== true);
  if (visible.length === 0) return null;

  const labeled = variant === "labeled";

  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button
        type="button"
        onClick={(event) => event.stopPropagation()}
        className={
          labeled
            ? "inline-flex items-center gap-1 rounded-full border border-slate-300 bg-white px-3 py-1.5 text-sm font-semibold text-slate-800 hover:bg-slate-50"
            : "inline-flex items-center justify-center rounded-lg p-2 text-slate-500 hover:bg-slate-100 hover:text-slate-800"
        }
        aria-label={label}
      >
        {labeled ? (
          <>
            {label}
            <ChevronDownIcon className="h-4 w-4 text-slate-500" aria-hidden="true" />
          </>
        ) : (
          <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
        )}
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-20 mt-1 w-52 origin-top-right rounded-xl border border-slate-200 bg-white p-1 shadow-lg focus:outline-none">
          {header ? (
            <p className="px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-400">
              {header}
            </p>
          ) : null}
          {visible.map((item) => {
            const Icon = item.icon;
            const itemDisabled = Boolean(item.disabled || item.loading);
            return (
              <Menu.Item key={item.label} disabled={itemDisabled}>
                {({ active }) => (
                  <button
                    type="button"
                    disabled={itemDisabled}
                    className={`flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm disabled:cursor-not-allowed disabled:opacity-50 ${
                      item.danger
                        ? active
                          ? "bg-rose-50 text-rose-800"
                          : "text-rose-700"
                        : active
                          ? "bg-emerald-50 text-slate-900"
                          : "text-slate-700"
                    }`}
                    onClick={(event) => {
                      event.stopPropagation();
                      if (itemDisabled) return;
                      item.action?.();
                    }}
                  >
                    {item.loading ? (
                      <svg
                        className="h-4 w-4 animate-spin text-slate-400"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                    ) : Icon ? (
                      <Icon
                        className={`h-4 w-4 ${item.danger ? "text-rose-500" : "text-slate-400"}`}
                        aria-hidden="true"
                      />
                    ) : null}
                    {item.label}
                  </button>
                )}
              </Menu.Item>
            );
          })}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
